import React, {useEffect, useState} from "react";
import s from './TableContentRow.module.css'
import moment from "moment";
import imgSvg from "../../../../../img/Group 78.svg";
import {ReactComponent as PlusIcon} from "../../../../../img/plus_icon.svg";
import {ReactComponent as MinusIcon} from "../../../../../img/minus_icon.svg";
import {useDispatch, useSelector} from "react-redux";
import {Box, Grid, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {
    changeNumberOfCopiesForSelectedRow,
    changeNumberOfCopiesForSelectedRowForPriceTable,
    getDataForDownload,
    getDataForDownloadRegItems,
    setSelectedRow,
    setSelectedRowForPricesTable
} from "../../../../../Redux/content-reducer";

const useStyles = makeStyles(theme => ({
    tableRow: {
        direction: `rtl`,
        minHeight: `45px`,
        '& .MuiTypography-root': {
            textAlign: `center`,
            // wordBreak: `break-all`
        },
        '& > .MuiGrid-item': {
            borderRight: `1px solid #BABABA`,
            borderBottom: `1px solid #BABABA`,
            padding: `0 5px`,
            '&:last-child': {
                borderLeft: `1px solid #BABABA`,
            }
        }
    },
    tableCellBox: {
        display: `flex`,
        alignItems: `center`,
        justifyContent: `center`,
        height: `100%`
    }
}))

export const TableContentRow = (props) => {
    const dispatch = useDispatch();
    const {contentData, dropdownsReducer} = useSelector(state => state);
    const classes = useStyles();
    let [isSelected, isLastSelected, rowIndex] = [props.dataRow.selectedRow, props.dataRow.isLastSelected, props.dataRow.rowIndex];
    let [countNumber, changeCountNumber] = useState(1);
    // const isLastSelected = data.isLastSelected;
    // const rowIndex = data.rowIndex;
    moment.locale('es');
    // data.PrintedPageSizes.forEach((key) => {
    //    if(key === format){
    //        classNameForPrintFormat = s.greenDot;
    //    }
    // });

    const selectedRow = (e) => {
        const target = e.target;
        if (e.nativeEvent.shiftKey) {
            const indexForRow = target.dataset.rowindex;
            props.getSelectedRangeRows(Number(indexForRow), target);
        } else {
            let isChecked = target.checked, isLastSelected = true;
            if(contentData.isActivePromosScreen){
                const saleId = props.dataRow.SaleIdentifier;
                dispatch(setSelectedRow(isChecked, Number(saleId), isLastSelected));
            } else {
                const effectiveBarCode = Number(props.dataRow.EffectiveBarCode);
                dispatch(setSelectedRowForPricesTable(isChecked, effectiveBarCode, isLastSelected));
            }
        }
    };

    useEffect(() => {
        changeCountNumber(props.dataRow.numberOfCopies);
    }, [props.dataRow.numberOfCopies])

    let getDataForPrint = () => {
        if(contentData.isActivePromosScreen){
            const saleId = Number(props.dataRow.SaleIdentifier);
            const branchNo = localStorage.getItem('selectedOptionValue');
            props.changeSelectedIds([saleId]);
            const promoData = [{
                SaleIdentifier: saleId,
                NoSigns: props.dataRow.numberOfCopies
            }]
            dispatch(getDataForDownload(dropdownsReducer.format, promoData, branchNo, true));
        } else {
            const effectiveBarCode = Number(props.dataRow.EffectiveBarCode);
            const branchNo = localStorage.getItem('selectedOptionValue');
            props.changeSelectedIds([effectiveBarCode]);
            const itemData = [{
                EffectiveBarCode: effectiveBarCode,
                NoSigns: props.dataRow.numberOfCopies
            }]
            dispatch(getDataForDownloadRegItems(dropdownsReducer.format, itemData, branchNo, true));
        }
    };

    const increaseCount = () => {
        if(contentData.isActivePromosScreen){
            const saleId = Number(props.dataRow.SaleIdentifier);
            if(countNumber + 1 <= 9){
                dispatch(changeNumberOfCopiesForSelectedRow(saleId, countNumber + 1));
            }
        } else {
            const effectiveBarCode = Number(props.dataRow.EffectiveBarCode);
            if (countNumber + 1 <= 9) {
                dispatch(changeNumberOfCopiesForSelectedRowForPriceTable(effectiveBarCode, countNumber + 1));
            }
        }
    }

    const decreaseCount = () => {
        if(contentData.isActivePromosScreen){
            const saleId = Number(props.dataRow.SaleIdentifier);
            if(countNumber - 1 >= 1){
                dispatch(changeNumberOfCopiesForSelectedRow(saleId, countNumber - 1));
            }
        } else {
            const effectiveBarCode = Number(props.dataRow.EffectiveBarCode);
            if (countNumber - 1 >= 1) {
                dispatch(changeNumberOfCopiesForSelectedRowForPriceTable(effectiveBarCode, countNumber - 1));
            }
        }
    }


    if (contentData.isActivePromosScreen) {
        let saleDate, saleDateConvert;
        if (props.dataRow.SaleEndDateTimeUtc !== "") {
            saleDate = new Date(props.dataRow.SaleEndDateTimeUtc);
            saleDateConvert = moment(saleDate).format('L');
        } else {
            saleDateConvert = ""
        }
        let barcodes;
        if (props.dataRow.BarCodes.length > 1) {
            barcodes = props.dataRow.BarCodes.join(', ')
        } else {
            barcodes = props.dataRow.BarCodes.join('')
        }

        return (
            <Grid
                container
                columns={24}
                data-saleid={props.dataRow.SaleIdentifier}
                className={classes.tableRow}
                // alignItems={`center`}
            >
                <Grid item xs={1.5}>
                    <Box className={classes.tableCellBox}>
                        <input type="checkbox" checked={isSelected} data-lastselected={isLastSelected}
                               data-rowindex={rowIndex} onChange={(e) => {
                            selectedRow(e);
                        }}/>
                    </Box>
                </Grid>
                <Grid item xs={1}>
                    <Box className={classes.tableCellBox}>
                        <img onClick={(e) => {
                            getDataForPrint(e);
                        }} className={s.downloadIcon} src={imgSvg} alt="img"/>
                    </Box>
                </Grid>
                {/*<td>{data.referenceNo}</td>*/}
                <Grid item xs={1}>
                    <Box className={classes.tableCellBox}>
                        <Typography>
                            {Number(props.dataRow.SaleIdentifier)}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={1}>
                    <Box className={classes.tableCellBox}>
                        <Typography>
                            {Number(props.dataRow.SaleType)}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={1.5}>
                    <Box className={classes.tableCellBox}>
                        <Typography>
                            {saleDateConvert}
                        </Typography>
                    </Box>
                </Grid>
                {/*<td>Department</td>*/}
                <Grid item xs>
                    <Box className={classes.tableCellBox}>
                        <Typography>
                            {barcodes}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs>
                    <Box className={classes.tableCellBox}>
                        <Typography>
                            {props.dataRow.PromotionDescription}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs>
                    <Box className={classes.tableCellBox}>
                        <Typography>
                            {props.dataRow.RussianPromotionDescription}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={1}>
                    <Box className={classes.tableCellBox}>
                        <Typography>
                            {Number(props.dataRow.SaleVal1).toFixed(2)}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={1}>
                    <Box className={classes.tableCellBox}>
                        <Typography>
                            {Number(props.dataRow.SaleVal2).toFixed(2)}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={1}>
                    <Box className={classes.tableCellBox}>
                        <Typography>
                            {Number(props.dataRow.RegularPrice).toFixed(2)}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={1}>
                    <Box className={classes.tableCellBox}>
                        <span className={props.dataRow.Members === 1 ? s.greenDot : s.redDot}>

                        </span>
                    </Box>
                </Grid>
                <Grid item xs={1.5}>
                    <Box className={classes.tableCellBox}>
                        <div className={s.counterWrapper}>
                            <PlusIcon className={`${s.numberOfCopyIncrease} ${countNumber === 9 ? s.disabledBtn : ''}`}
                                      onClick={increaseCount}/>
                            <div className={s.numberOfCopy}>{countNumber}</div>
                            <MinusIcon className={`${s.numberOfCopyDecrease} ${countNumber === 1 ? s.disabledBtn : ''}`}
                                       onClick={decreaseCount}/>
                        </div>
                    </Box>
                </Grid>
                <Grid item xs={1.5}>
                    <Box className={classes.tableCellBox}>
                        <span className={props.dataRow.isAlreadyPrinted ? s.greenDot : s.redDot}>

                        </span>
                    </Box>
                </Grid>
            </Grid>
        )
    }

    return (
        <Grid
            container
            columns={24}
            className={classes.tableRow}
            data-effectivebarcode={props.dataRow.EffectiveBarCode}
        >
            <Grid item xs={1.5}>
                <Box className={classes.tableCellBox}>
                    <input type="checkbox" checked={isSelected} data-lastselected={isLastSelected}
                           data-rowindex={rowIndex}
                           onChange={(e) => {
                               selectedRow(e);
                           }}/>
                </Box>
            </Grid>
            <Grid item xs={1}>
                <Box className={classes.tableCellBox}>
                    <img onClick={(e) => {
                        getDataForPrint(e);
                    }} className={s.downloadIcon} src={imgSvg} alt="img"/>
                </Box>
            </Grid>
            <Grid item xs={3}>
                <Box className={classes.tableCellBox}>
                    <Typography>
                        {props.dataRow.EffectiveBarCode}
                    </Typography>
                </Box>
            </Grid>
            <Grid item xs>
                <Box className={classes.tableCellBox}>
                    <Typography>
                        {props.dataRow.ProductName}
                    </Typography>
                </Box>
            </Grid>
            <Grid item xs>
                <Box className={classes.tableCellBox}>
                    <Typography>
                        {props.dataRow.RussianProductName}
                    </Typography>
                </Box>
            </Grid>
            <Grid item xs={1.5}>
                <Box className={classes.tableCellBox}>
                    <Typography>
                        {Number(props.dataRow.Price).toFixed(2)}
                    </Typography>
                </Box>
            </Grid>
            <Grid item xs={1.5}>
                <Box className={classes.tableCellBox}>
                    <div className={s.counterWrapper}>
                        <PlusIcon className={`${s.numberOfCopyIncrease} ${countNumber === 9 ? s.disabledBtn : ''}`}
                                  onClick={increaseCount}/>
                        <div className={s.numberOfCopy}>{countNumber}</div>
                        <MinusIcon className={`${s.numberOfCopyDecrease} ${countNumber === 1 ? s.disabledBtn : ''}`}
                                   onClick={decreaseCount}/>
                    </div>
                </Box>
            </Grid>
            <Grid item xs={1.5}>
                <Box className={classes.tableCellBox}>
                    <span className={props.dataRow.isAlreadyPrinted ? s.greenDot : s.redDot}>

                    </span>
                </Box>
            </Grid>
        </Grid>
    )
}